import { render, staticRenderFns } from "./tidings_of_glad_tidings.vue?vue&type=template&id=039226bf&scoped=true&"
import script from "./tidings_of_glad_tidings.vue?vue&type=script&lang=js&"
export * from "./tidings_of_glad_tidings.vue?vue&type=script&lang=js&"
import style0 from "./tidings_of_glad_tidings.vue?vue&type=style&index=0&id=039226bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039226bf",
  null
  
)

export default component.exports